
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src2815122270/src/vl-app/pages/patients/test-call.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import dynamic from 'next/dynamic';
import Header from '@components/Layouts/Header/Header';

const PatientTestCallSession = dynamic(() => import('@components/Patients/TestCallSession/PatientTestCallSession'), {
  ssr: false
});

const PatientTestCall = () => {
  return (
    <div className="page-container">
      <Header pageType="patients" pageTitle="Test Call" />
      <section className="section-layout patient-test-call patient">
        <main className="container" id="page-content">
          <PatientTestCallSession />
        </main>
      </section>
    </div>
  );
};

export default PatientTestCall;
export const Route = createFileRoute('/patients/test-call')({ component: PatientTestCall });
